export default {"src":"/_next/static/media/Content-7.4d317274.svg","height":186,"width":461};